import classes from "./Spinner.module.css";

export type SpinnerVariant = "primary" | "white";

interface Props {
  variant?: SpinnerVariant;
}

const Spinner = ({ variant }: Props) => {
  if (variant === "white") {
    return <div className={classes.whiteSpinner} />;
  }
  return <div className={classes.spinner} />;
};

export default Spinner;
